
export const model = {
    // asset information
    code: '',
    description: '',
};